import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const TOKEN_KEY = "thara_token";
export const USER_KEY = "thara_user";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const getUser = () => {
  const raw = localStorage.getItem(USER_KEY);
  return raw ? JSON.parse(raw) : null;
};

export const setSession = (token, user) => {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(USER_KEY, JSON.stringify(user));
};

export const clearSession = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
};

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401 && !err.config.url.includes("/auth/login")) {
      clearSession();
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    // Normalise error `detail` to a string so components can safely render it
    // (Pydantic 422 responses are arrays of objects — passing them straight
    // into <toast.error /> crashes React with "Objects are not valid as a
    // React child" and unmounts the whole page).
    try {
      const d = err?.response?.data?.detail;
      if (Array.isArray(d)) {
        err.response.data.detail = d
          .map((e) => {
            const loc = Array.isArray(e?.loc) ? e.loc.slice(-1).join(".") : "";
            return [loc, e?.msg].filter(Boolean).join(" — ");
          })
          .filter(Boolean)
          .join("; ") || "Validation error";
      } else if (d && typeof d === "object") {
        err.response.data.detail = d.msg || JSON.stringify(d);
      }
    } catch (_e) { /* leave detail untouched */ }
    return Promise.reject(err);
  }
);

export default api;

// Helper to build authenticated image URLs.
// New images from Bunny CDN come as absolute https URLs — return as-is.
// Legacy images (storage_path only) go through the /api/files/ proxy with ?auth= token.
export const buildImageUrl = (storagePathOrUrl) => {
  if (!storagePathOrUrl) return "";
  if (typeof storagePathOrUrl === "string" && /^https?:\/\//i.test(storagePathOrUrl)) {
    return storagePathOrUrl;
  }
  const token = getToken();
  return `${API}/files/${storagePathOrUrl}?auth=${encodeURIComponent(token || "")}`;
};
